import { c as _c } from "react/compiler-runtime";
import { CopyIcon, MoreVerticalIcon, Trash2Icon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { toast } from '@/components/ui/toast';
import { useCommentContext } from '@/contexts/comment.context';
import { useCommentsContext } from '@/contexts/comments.context';
import { useDeletePostComment } from '@/hooks/queries/comment.query';
import { useCopyToClipboard } from '@/hooks/use-copy-to-clipboard';
import { useSession } from '@/lib/auth-client';
export function CommentMenu() {
  const $ = _c(66);
  const {
    comment
  } = useCommentContext();
  const {
    slug
  } = useCommentsContext();
  const {
    data: session
  } = useSession();
  const [copy] = useCopyToClipboard();
  const [open, setOpen] = useState(false);
  const t = useTranslations();
  let t0;
  if ($[0] !== slug) {
    t0 = {
      slug
    };
    $[0] = slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = () => {
      toast.add({
        type: "success",
        title: t("success.comment-deleted"),
        data: {
          testId: "comment-deleted-toast"
        }
      });
    };
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    mutate: deleteComment,
    isPending: isDeleting
  } = useDeletePostComment(t0, t1);
  const {
    isDeleted,
    id,
    user: t2,
    parentId
  } = comment;
  const {
    id: userId
  } = t2;
  const commentQuery = parentId ? `comment=${parentId}&reply=${id}` : `comment=${id}`;
  const isAuthor = !isDeleted && session?.user.id === userId;
  let t3;
  if ($[4] !== deleteComment || $[5] !== id || $[6] !== isDeleting) {
    t3 = function handleDeleteComment() {
      if (isDeleting) {
        return;
      }
      deleteComment({
        id
      });
    };
    $[4] = deleteComment;
    $[5] = id;
    $[6] = isDeleting;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleDeleteComment = t3;
  let t4;
  if ($[8] !== t) {
    t4 = t("blog.comments.open-menu");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MoreVerticalIcon />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <DropdownMenuTrigger render={<Button variant="ghost" size="icon-sm" aria-label={t4} data-testid="comment-menu-button">{t5}</Button>} />;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== commentQuery || $[14] !== copy || $[15] !== slug || $[16] !== t) {
    t7 = () => {
      copy({
        text: `${globalThis.location.origin}/blog/${slug}?${commentQuery}`,
        successMessage: t("success.link-copied")
      });
    };
    $[13] = commentQuery;
    $[14] = copy;
    $[15] = slug;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CopyIcon />;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("blog.comments.copy-link");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t9) {
    t10 = <DropdownMenuItem onClick={t7}>{t8} {t9}</DropdownMenuItem>;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isAuthor || $[25] !== isDeleting || $[26] !== t) {
    t11 = isAuthor && <DropdownMenuItem disabled={isDeleting} aria-disabled={isDeleting} data-testid="comment-delete-button" variant="destructive" onClick={() => {
      setOpen(true);
    }}><Trash2Icon />{t("common.delete")}</DropdownMenuItem>;
    $[24] = isAuthor;
    $[25] = isDeleting;
    $[26] = t;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11) {
    t12 = <DropdownMenuContent align="end" className="min-w-36">{t10}{t11}</DropdownMenuContent>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t6) {
    t13 = <DropdownMenu>{t6}{t12}</DropdownMenu>;
    $[31] = t12;
    $[32] = t6;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t) {
    t14 = t("common.dialogs.delete-comment.title");
    $[34] = t;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t14) {
    t15 = <AlertDialogTitle>{t14}</AlertDialogTitle>;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t) {
    t16 = t("common.dialogs.delete-comment.description");
    $[38] = t;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t16) {
    t17 = <AlertDialogDescription>{t16}</AlertDialogDescription>;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t15 || $[43] !== t17) {
    t18 = <AlertDialogHeader>{t15}{t17}</AlertDialogHeader>;
    $[42] = t15;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t) {
    t19 = t("common.cancel");
    $[45] = t;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t19) {
    t20 = <AlertDialogCancel>{t19}</AlertDialogCancel>;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t) {
    t21 = t("common.delete");
    $[49] = t;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== handleDeleteComment || $[52] !== t21) {
    t22 = <AlertDialogAction onClick={handleDeleteComment} variant="destructive" data-testid="comment-dialog-delete-button">{t21}</AlertDialogAction>;
    $[51] = handleDeleteComment;
    $[52] = t21;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t20 || $[55] !== t22) {
    t23 = <AlertDialogFooter>{t20}{t22}</AlertDialogFooter>;
    $[54] = t20;
    $[55] = t22;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t18 || $[58] !== t23) {
    t24 = <AlertDialogContent data-testid="comment-dialog">{t18}{t23}</AlertDialogContent>;
    $[57] = t18;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== open || $[61] !== t24) {
    t25 = <AlertDialog open={open} onOpenChange={setOpen}>{t24}</AlertDialog>;
    $[60] = open;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== t13 || $[64] !== t25) {
    t26 = <>{t13}{t25}</>;
    $[63] = t13;
    $[64] = t25;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  return t26;
}